import { render, staticRenderFns } from "./Datetime.vue?vue&type=template&id=64ea608c&"
import script from "./Datetime.vue?vue&type=script&lang=js&"
export * from "./Datetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ea608c')) {
      api.createRecord('64ea608c', component.options)
    } else {
      api.reload('64ea608c', component.options)
    }
    module.hot.accept("./Datetime.vue?vue&type=template&id=64ea608c&", function () {
      api.rerender('64ea608c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Datetime.vue"
export default component.exports